import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import IAccessoriesCategory from '../../../../../model/accessories/IAccessoriesCategory';
import accessoriesCategoriesStyles from './accessoriesCategoriesStyles';
import AccessoryCategory from './AccessoriesCategory';

export interface IAccessoriesCategoriesProps {
  accessoriesCategories: IAccessoriesCategory[];
  selectedAccessories: string[];
  onClick: (name: string) => void;
}

const AccessoriesCategories: FunctionComponent<IAccessoriesCategoriesProps> = ({
  accessoriesCategories,
  onClick,
  selectedAccessories,
}) => {
  const styles = accessoriesCategoriesStyles();

  return (
    <Box className={styles.container}>
      {accessoriesCategories?.map(accessoryCategory => (
        <AccessoryCategory
          key={accessoryCategory.name}
          selectedAccessories={selectedAccessories}
          accessoryCategory={accessoryCategory}
          onClick={onClick}
        />
      ))}
    </Box>
  );
};

export default AccessoriesCategories;
